import {
  ActiveWorkshopSystemResponse,
  CalendarDayTimeSlotResponse,
  CampaignResponse,
  CustomerResponse,
  DealerResponse,
  EbuCarModelResponse,
  ExternalTyreUrlResponse,
  GetTechUpdateStatusResponse,
  InsuranceCompanyResponse,
  PackageResponse,
  PackageTypeEnum,
  SelectedPackagesRequest,
  VehicleSearchResponse,
  VehicleWarningLightsResponse,
  WorkshopSystemEnum
} from "src/domain/client";
import {
  ContactInformation,
  DiscountCodeValidationStateEnum,
  IBookingError,
  SelectedPackages
} from "./utils/booking.modals";

export interface AppError {
  status: number;
  message: string;
}

export interface BookingState {
  // Step 1
  chassiNumber: string | null;
  odometer: number | null;
  searchedByRegno: boolean;
  providerIds: string[] | null;
  carInfo: VehicleSearchResponse | null;
  techUpdateStatus: GetTechUpdateStatusResponse | null;
  // Step 2
  activeWorkshopSystems: ActiveWorkshopSystemResponse[] | null;
  selectedWorkshopSystems: WorkshopSystemEnum[] | null;
  // Step 3
  dealers: DealerResponse[] | null;
  selectedDealerNumber: string | null;
  enabledServiceTypes: PackageTypeEnum[] | null;
  // Step 4
  basePackages: PackageResponse[] | null;
  insuranceProviders: InsuranceCompanyResponse[] | null;
  warningLights: VehicleWarningLightsResponse[] | null;
  vehicleSegment: number | null;
  externalTyreUrl: ExternalTyreUrlResponse | null;
  selectedPackages: SelectedPackages | null;
  rejectedIsOnlyTyre: boolean;
  fileIds: string[];
  // Step 4 & Step 5
  additionalPackages: PackageResponse[] | null;
  // Step 6
  availableTimes: CalendarDayTimeSlotResponse[] | null;
  selectedDate: string | null;
  selectedTime: string | null;
  selectedDropoffOptionId: string | null;
  packagesUsedForTimeRequest: SelectedPackagesRequest[] | null;
  ebuCars: EbuCarModelResponse[] | null;
  selectedEbuCarId: string | null;
  // Step 7
  contactInformation: ContactInformation | null;
  campaignResponse: CampaignResponse | null;
  campaignValidationState: DiscountCodeValidationStateEnum;
  // Step 8
  orderId: string | null;
  bookingError: IBookingError | null;
  isBookingMadeSuccessful: boolean;
  // Business Proposal State
  proposalCustomer: CustomerResponse | null;
  isBusinessProposalActive: boolean;
  // Shared UI
  isLoading: boolean;
  isPartialLoading: boolean;
  error: AppError | null;
}

export const initialBookingState: BookingState = {
  chassiNumber: null,
  odometer: null,
  searchedByRegno: true,
  providerIds: null,
  carInfo: null,
  techUpdateStatus: null,
  activeWorkshopSystems: null,
  selectedWorkshopSystems: null,
  dealers: null,
  selectedDealerNumber: null,
  enabledServiceTypes: [
    PackageTypeEnum.OriginalService,
    PackageTypeEnum.BaseService
  ],
  basePackages: null,
  additionalPackages: null,
  availableTimes: null,
  insuranceProviders: null,
  warningLights: null,
  selectedPackages: null,
  vehicleSegment: null,
  externalTyreUrl: null,
  rejectedIsOnlyTyre: false,
  fileIds: [],
  selectedDate: null,
  selectedTime: null,
  selectedDropoffOptionId: null,
  packagesUsedForTimeRequest: null,
  ebuCars: null,
  selectedEbuCarId: null,
  contactInformation: null,
  campaignResponse: null,
  campaignValidationState: DiscountCodeValidationStateEnum.NotValidated,
  orderId: null,
  bookingError: null,
  isBookingMadeSuccessful: false,
  proposalCustomer: null,
  isBusinessProposalActive: false,
  isLoading: false,
  isPartialLoading: false,
  error: null
};
